export default function VendorDirective() {
  return {
    template: require('./vendor.html'),
    controller: 'VendorController',
    controllerAs: 'vendorVM',
    scope: {
      vendor: '=',
      deleteCallback: '&'
    },
    bindToController: true,
    replace: true,
  };
}
